import { $, $$ } from '../helper/utils';

// show the loader while ajax request is active
function load(button) {
  if (button.hasAttribute('disabled')) {
    button.removeAttribute('disabled');
  } else {
    button.setAttribute('disabled', true);
  }

  if (button.classList.contains('loading')) {
    button.classList.remove('loading');
  } else {
    button.classList.add('loading');
  }
}

// track only if status was succsessful
function trackStatus(form, data) {
  track(form.getAttribute('data-event'), 'Villiger', data.sso_accountId);
}

// show response message
function showMessage(form, type, msg = '', mode = '') {
  const target = form.querySelector('.alert');
  let message = '';

  if (msg.length) {
    if (target !== null) {
      target.classList.remove('hidden-xs-up');
      target.classList.remove('alert-success', 'alert-danger', 'alert-warning', 'alert-info');
    }


    try {
      const msgContent = JSON.parse(msg);
      message = `<b>${msgContent[0]}</b>&nbsp;${msgContent[1]}`;

      if (msgContent[0] == 'Erfolgreich' && msgContent[1] == 'angemeldet') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Inscrit avec succès';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Ein Account mit dieser E-Mail Adresse existiert bereits') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Un compte avec cet e-mail existe déjà';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Konto und/oder Passwort leer') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Compte et/ou mot de passe vide';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Das Passwort ist nicht korrekt') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Nom d\'utilisateur ou mot de passe incorrect';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Der Account existiert nicht oder ist nicht aktiviert') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Le compte n\'existe pas ou n\'est pas activé';
        }
      }

      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Der Account existiert nicht oder ist nicht aktiviert') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Le compte n\'existe pas ou n\'est pas activé';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Konto mit diesem Benutzernamen existiert, ist aber nicht aktiviert') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Le compte n\'existe pas ou n\'est pas activé';
        }
      }
      if (msgContent[0] == 'Fehler:' && msgContent[1] == 'Deine Eingabe und die Wiederholung des neuen Passwortes stimmen nicht überein') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Ta saisie et la répétition du nouveau mot de passe ne correspondent pas';
        }
      }
      if (msgContent[0] == 'Erfolgreich' && msgContent[1] == 'Passwort erfolgreich geändert') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Mot de passe modifié avec succès';
        }
      }
      if (msgContent[0] == 'Erfolgreich' && msgContent[1] == 'E-Mail wurde versendet') {
        if (document.body.dataset.langid == 'fr') {
          message = 'L\'e-mail a été envoyé';
        }
      }
      if (msgContent[0] == 'Erfolgreich' && msgContent[1] == 'Account existiert noch nicht') {
        if (document.body.dataset.langid == 'fr') {
          message = 'Le compte n\'existe pas encore';
        }
      }
    } catch (e) {

    }

    if (type) {
      switch (type) {
        case 200:
          if (target !== null) {
            target.classList.add('alert-success');
            target.innerHTML = message;
          }
          if (mode === 'login' || mode === 'login-facebook') {
            setTimeout((e) => {
              window.location.reload();
            }, 3000);
            if (form.hasAttribute('data-url')) {
              if (form.getAttribute('data-url').length) {
                // window.location = form.getAttribute('data-url');
              }
            } else {
              // window.location.reload(false);
            }
          }
          break;
          // case 500:
          //     target.classList.add('alert-danger');
          //     target.innerHTML = message;
          //     break;
        case 400:
          // target.classList.add('alert-warning');
          if (target !== null) {
            target.classList.add('alert-danger');
            target.innerHTML = message;
          }
          break;
        case 300:
          if (target !== null) {
            target.classList.add('alert-info');
            target.innerHTML = message;
          }
          break;
      }
    } else if (target !== null) {
      target.classList.add('hidden-xs-up');
    }
  }
}

function ajaxRequest(mode, data, form, c, m) {
  if (typeof c === 'undefined' && typeof m === 'undefined') {
    c = 'SEY5QUtYd2YxZTVrT0hRc3pVSGRzWGZPRjIxZXh4K254NVkvRHJhMEc3WHNyQUJWcTEvMjZjY0lPSXNxVnpWcA==';
    m = 'YVlXVlNxWnl2aU9JdmV0c0psZFZhZz09';
  }

  const langId = document.body.getAttribute('data-langid');

  const request = new XMLHttpRequest();

  const requestUrl = '/veo/ajaxRequest.php';

  let requestData = `c=${c}&m=${m}&l=${langId}`;

  if (form !== null) {
    request.onload = function (e) {
      if (mode === 'login-facebook') {
        form = $('.login-account');
        // load(form.querySelector('button.fb-login'));
      } else if (mode === 'connect-facebook') {
        // load(form.querySelector('button.fb-login'));
      } else if (mode === 'register-facebook') {
        // load(form.querySelector('button.fb-login'));
      } else {
        load(form.querySelector('button[type=submit]'));
      }
      ajaxResponse(form, e, mode);
    };
  }

  if (!request) {
    console.error('Giving up :( Cannot create an XMLHTTP instance');
    return false;
  }

  request.open('POST', requestUrl);

  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

  if (typeof mode !== 'undefined' && mode !== '') {
    if (mode == 'register-account') {
      
      const tac = document.querySelector('[name="tac"]').checked ? 'tac' : '';
      const ns = document.querySelector('[name="newsletter"]').checked ? 'ns' : '';
      const smoker = document.querySelector('[name="smoker"]').checked;
      
      let sc1 = 0;
      let sc2 = 0;
      let sc3 = 0;
      let sc4 = 0;
      let sc5 = 0;
      if (smoker) {
        sc1 = document.querySelector('[name="sc-1"]').checked ? 1 : 0;
        sc2 = document.querySelector('[name="sc-2"]').checked ? 1 : 0;
        sc3 = document.querySelector('[name="sc-3"]').checked ? 1 : 0;
        sc4 = document.querySelector('[name="sc-4"]').checked ? 1 : 0;
        sc5 = document.querySelector('[name="sc-5"]').checked ? 1 : 0;
      }
      data += `&tac=${tac}&ns=${ns}&sc-1=${sc1}&sc-2=${sc2}&sc-3=${sc3}&sc-4=${sc4}&sc-5=${sc5}`;
    }
    let cleanedData = '';
    // get data as array
    const dataArray = data.split('&');
    // loop through array
    for (let i = 0; i < dataArray.length; i++) {
      // get key and value
      const dataKeyValue = dataArray[i].split('=');
      // get key
      const dataKey = dataKeyValue[0];
      // check if key is in cleanedData string
      if (!cleanedData.includes(dataKey) || dataKey == 'ns') {
        // if not, add it
        cleanedData += `${dataKey}=${dataKeyValue[1]}&`;
      }
    }

    requestData += `&mode=${mode}&${cleanedData}`;

    request.send(requestData);
  } else {
    console.info('mode must be set');
  }
}

function ajaxResponse(form, e, mode) {
  if (e.currentTarget.readyState === 4 && e.currentTarget.status === 200) {
    if (e.currentTarget.response) {
      const status = JSON.parse(e.currentTarget.response);
      showMessage(form, status.status, status.msg, mode);
      // custom action for special modes
      if (status.status === 200) {
        if (mode === 'check-account') {
          const mySwiper = $('.swiper-container').swiper;
          const registerAddressForm = $('.register-address');

          registerAddressForm.elements[0].value = 'checked';

          mySwiper.slideNext();
          document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });

          // go to next form
        } else if (mode === 'register-facebook') {
          const mySwiper = $('.swiper-container').swiper;
          const { data } = status;

          const registerAccountForm = $('.register-account');

          for (let i = 0; i < registerAccountForm.elements.length; i++) {
            const field = registerAccountForm.elements[i];
            if (typeof (data[field.name]) !== 'undefined') {
              field.value = data[field.name];
            }
          }

          const registerAddressForm = $('.register-address');

          registerAddressForm.elements[0].value = 'checked';

          for (let i = 0; i < registerAddressForm.elements.length; i++) {
            const field = registerAddressForm.elements[i];

            if (typeof (data[field.name]) !== 'undefined') {
              if (field.name === 'gender') {
                if (field.value === data[field.name]) {
                  field.setAttribute('checked', true);
                }
              } else {
                field.value = data[field.name];
              }
            }
          }

          const registerFinalForm = $('.register-password');

          const fields = $$('.field-info');
          if (fields.length) {
            for (let i = 0; i < fields.length; i++) {
              fields[i].remove();
            }
          }

          for (let i = 0; i < registerFinalForm.elements.length; i++) {
            if (registerFinalForm[i].name === 'password') {
              registerFinalForm[i].remove();
            }
            if (registerFinalForm[i].name === 'password2') {
              registerFinalForm[i].remove();
            }
          }
          mySwiper.slideNext();
          document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
        if (mode === 'login' || mode === 'login-facebook') {
          form.classList.add('hide');
          // form.classList.add('redirect');
          // trackStatus(form, status.data);
        }
        if (mode === 'register-account') {
          const mySwiper = $('.swiper-container').swiper;
          mySwiper.slideNext();
          document.body.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
        if (form.getAttribute('data-url')) {
          if (form.getAttribute('data-url').length) {
            window.location = form.getAttribute('data-url');
          }
        }
        if (mode === 'update-smoke-profile') {
          if (status.status === 200) {
            const aside = $('.profile-update-modal');
            aside.setAttribute('aria-hidden', 'true');
            aside.classList.remove('modal-active');
            document.documentElement.classList.remove('noscroll');
          }
        }
      }
    }
  } else {
    load(form.querySelector('button[type=submit]'));
    showMessage(form, 'Error', 'Request failed!');
  }
}

function validateEmail(email) {
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}

function checkFormFields(form) {
  const formFields = form.elements;
  const formFieldsValue = [];
  const errorMap = new Map();

  const ua = window.navigator.userAgent;
  const isIE = /MSIE|Trident/.test(ua);

  for (let i = 0; i < formFields.length; i++) {
    const field = formFields[i];

    if (field.type !== 'submit') {
      field.addEventListener('change', (e) => {
        if (field.classList.contains('required')) {
          if (field.type === 'text' || field.type === 'email' || field.type === 'password') {
            if (field.value.length > 2) {
              field.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              field.classList.add('is-invalid');
              // error = true;
              errorMap.set(field, true);
            }

            if (field.getAttribute('name') == 'username') {
              if (validateEmail(field.value)) {
                field.classList.remove('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                formFieldsValue.push(
                  `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
                );
              } else {
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                field.classList.add('is-invalid');
                // error = true;
                errorMap.set(field, true);
              }
            }

            if (field.getAttribute('name') === 'birthday') {
              if (field.value.length) {
                const birthday = parseDate(field.value, 'dd.mm.yyyy');


                const age = checkAge(birthday);
                if (age >= 18 && age <= 120) {
                  formFields[i].classList.remove('is-invalid');
                  try {
                    field.parentElement.querySelector('.error-label').classList.remove('show');
                  } catch (e) {

                  }
                } else {
                  formFields[i].classList.add('is-invalid');
                  try {
                    field.parentElement.querySelector('.error-label').classList.add('show');
                  } catch (e) {

                  }
                  // error = true;
                  errorMap.set(field, true);
                }
              } else {
                formFields[i].classList.add('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                // error = true;
                errorMap.set(field, true);
              }
            }

            if (field.getAttribute('name') == 'password') {
              if (field.value.length >= 8) {
                field.classList.remove('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                formFieldsValue.push(
                  `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
                );
              } else {
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                field.classList.add('is-invalid');
                // error = true;
                errorMap.set(field, true);
              }
            }
            if (field.getAttribute('name') == 'password2') {
              console.log(field.parentElement.parentElement.querySelector('[name="password"]').value);
              if (field.parentElement.parentElement.querySelector('[name="password"]').value == field.value) {
                field.classList.remove('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                formFieldsValue.push(
                  `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
                );
              } else {
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                field.classList.add('is-invalid');
                // error = true;
                errorMap.set(field, true);
              }
            }
          } else if (field.type === 'select-one') {
            if (isIE) {
              if (field.value !== '') {
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                field.parentElement.classList.remove('is-invalid');
                formFieldsValue.push(
                  `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
                );
              } else {
                field.parentElement.classList.add('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                // error = true;
                errorMap.set(field, true);
              }
            } else if (field.selectr != null) {
              if (field.selectr.getValue() !== '') {
                field.parentElement.classList.remove('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                formFieldsValue.push(
                  `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
                );
              } else {
                field.parentElement.classList.add('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                // error = true;
                errorMap.set(field, true);
              }
            }
          }

          // non required fields
        } else if (field.type !== 'checkbox' && field.type !== 'radio') {
          if (formFields[i].value.length > 0) {
            formFieldsValue.push(
              `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
            );
          }
        }

        if (field.type === 'select-one') {
          const { value } = field.options[field.selectedIndex];
          if (value == '' || value == null) {
            field.classList.add('is-invalid');
            try {
              field.parentElement.querySelector('.error-label').classList.add('show');
            } catch (e) {

            }
          } else {
            field.classList.remove('is-invalid');
            try {
              field.parentElement.querySelector('.error-label').classList.remove('show');
            } catch (e) {

            }
          }
        }

        if (field.type === 'radio') {
          const radioElements = $$(`[name=${field.name}]`);
          let radioValue = '';
          let checked = false;

          for (let i = 0; i < radioElements.length; i++) {
            if (radioElements[i].checked) {
              checked = true;
              radioValue = radioElements[i].value;
              radioElements[i].classList.remove('is-invalid');
              try {
                field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
            } else {
              radioElements[i].classList.add('is-invalid');
              try {
                field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              // error = true;
              errorMap.set(field, true);
            }
          }

          if (checked) {
            const fieldValue = `${encodeURIComponent(field.name)}=${encodeURIComponent(radioValue)}`;
            for (let i = 0; i < radioElements.length; i++) {
              radioElements[i].classList.remove('is-invalid');
              try {
                field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              // error = false;
              errorMap.delete(field);
            }
            if (isIE) {
              if (!formFieldsValue.filter((f) => (f[0] === fieldValue ? 1 : 0))) {
                formFieldsValue.push(
                  fieldValue,
                );
              }
            } else if (!formFieldsValue.find((f) => (f === fieldValue ? 1 : 0))) {
              formFieldsValue.push(
                fieldValue,
              );
            }
          }
        }

        if (field.type === 'checkbox' && field.classList.contains('required')) {
          const checkElements = $$(`[name=${field.name}]`);
          let checkValue = '';

          if (field.getAttribute('name') == 'tac') {
            if (field.checked) {
              try {
                field.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
            } else {
              try {
                field.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
            }
          } else {
            for (let i = 0; i < checkElements.length; i++) {
              if (checkElements[i].checked) {
                checked = true;
                checkValue = checkElements[i].value;
                checkElements[i].classList.remove('is-invalid');
                try {
                  field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
              } else if (checkElements[i].classList.contains('required')) {
                checkElements[i].classList.add('is-invalid');
                try {
                  field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                // error = true;
                checked = false;
                errorMap.set(field, true);
              }
            }

            if (checked) {
              const fieldValue = `${encodeURIComponent(field.name)}=${encodeURIComponent(checkValue)}`;
              for (let i = 0; i < checkElements.length; i++) {
                checkElements[i].classList.remove('is-invalid');
                try {
                  field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
                errorMap.delete(field);
              }
              if (isIE) {
                if (!formFieldsValue.filter((f) => (f[0] === fieldValue ? 1 : 0))) {
                  formFieldsValue.push(
                    fieldValue,
                  );
                }
              } else if (!formFieldsValue.find((f) => (f === fieldValue ? 1 : 0))) {
                formFieldsValue.push(
                  fieldValue,
                );
              }
            }
          }
        }
      });

      if (field.type === 'select-one') {
        const { value } = field.options[field.selectedIndex];
        if (value == '' || value == null) {
          field.classList.add('is-invalid');
          try {
            field.parentElement.querySelector('.error-label').classList.add('show');
          } catch (e) {

          }
        }
      }
      if (field.type === 'radio') {
        const radioElements = $$(`[name=${field.name}]`);
        let radioValue = '';
        let checked = false;

        for (let i = 0; i < radioElements.length; i++) {
          if (radioElements[i].checked) {
            checked = true;
            radioValue = radioElements[i].value;
          } else {
            radioElements[i].classList.add('is-invalid');
            try {
              field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
            } catch (e) {

            }
            // error = true;
            errorMap.set(field, true);
          }
        }

        if (checked) {
          const fieldValue = `${encodeURIComponent(field.name)}=${encodeURIComponent(radioValue)}`;
          for (let i = 0; i < radioElements.length; i++) {
            radioElements[i].classList.remove('is-invalid');
            try {
              field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
            } catch (e) {

            }
            // error = false;
            errorMap.delete(field);
          }
          if (isIE) {
            if (!formFieldsValue.filter((f) => (f[0] === fieldValue ? 1 : 0))) {
              formFieldsValue.push(
                fieldValue,
              );
            }
          } else if (!formFieldsValue.find((f) => (f === fieldValue ? 1 : 0))) {
            formFieldsValue.push(
              fieldValue,
            );
          }
        }
      }

      if (field.type === 'checkbox' && field.classList.contains('required')) {
        let checked = false;
        if (field.getAttribute('name') == 'tac') {
          if (field.checked) {
            checked = true;
          } else {
            field.classList.add('is-invalid');
            try {
              field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
            } catch (e) {

            }
            checked = false;
            errorMap.set(field, true);
          }
        } else {
          const checkElements = $$(`[name=${field.name}]`);

          let checkValue = '';

          for (let i = 0; i < checkElements.length; i++) {
            if (checkElements[i].checked) {
              checked = true;
              checkValue = checkElements[i].value;
            } else if (checkElements[i].classList.contains('required')) {
              checkElements[i].classList.add('is-invalid');
              try {
                field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              // error = true;
              checked = false;
              errorMap.set(field, true);
            }
          }

          if (checked) {
            const fieldValue = `${encodeURIComponent(field.name)}=${encodeURIComponent(checkValue)}`;
            for (let i = 0; i < checkElements.length; i++) {
              checkElements[i].classList.remove('is-invalid');
              try {
                field.parentElement.parentElement.parentElement.querySelector.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              errorMap.delete(field);
            }
            if (isIE) {
              if (!formFieldsValue.filter((f) => (f[0] === fieldValue ? 1 : 0))) {
                formFieldsValue.push(
                  fieldValue,
                );
              }
            } else if (!formFieldsValue.find((f) => (f === fieldValue ? 1 : 0))) {
              formFieldsValue.push(
                fieldValue,
              );
            }
          }
        }
      }

      // required fields
      if (field.classList.contains('required')) {
        if (field.type === 'text' || field.type === 'email' || field.type === 'password') {
          if (field.value.length > 2) {
            field.classList.remove('is-invalid');
            try {
              field.parentElement.querySelector('.error-label').classList.remove('show');
            } catch (e) {

            }
            formFieldsValue.push(
              `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
            );
          } else {
            try {
              field.parentElement.querySelector('.error-label').classList.add('show');
            } catch (e) {

            }
            field.classList.add('is-invalid');
            // error = true;
            errorMap.set(field, true);
          }

          if (field.getAttribute('name') == 'username') {
            if (validateEmail(field.value)) {
              field.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              field.classList.add('is-invalid');
              // error = true;
              errorMap.set(field, true);
            }
          }

          if (field.getAttribute('name') === 'birthday') {
            if (field.value.length) {
              const birthday = parseDate(field.value, 'dd.mm.yyyy');


              const age = checkAge(birthday);
              if (age >= 18 && age <= 120) {
                formFields[i].classList.remove('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.remove('show');
                } catch (e) {

                }
              } else {
                formFields[i].classList.add('is-invalid');
                try {
                  field.parentElement.querySelector('.error-label').classList.add('show');
                } catch (e) {

                }
                // error = true;
                errorMap.set(field, true);
              }
            } else {
              formFields[i].classList.add('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              // error = true;
              errorMap.set(field, true);
            }
          }

          if (field.getAttribute('name') == 'password') {
            if (field.value.length >= 8) {
              field.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              field.classList.add('is-invalid');
              // error = true;
              errorMap.set(field, true);
            }
          }
          if (field.getAttribute('name') == 'password2') {
            console.log(field.parentElement.parentElement.querySelector('[name="password"]').value);
            if (field.parentElement.parentElement.querySelector('[name="password"]').value == field.value) {
              field.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              field.classList.add('is-invalid');
              // error = true;
              errorMap.set(field, true);
            }
          }
        } else if (field.type === 'select-one') {
          if (isIE) {
            if (field.value !== '') {
              field.parentElement.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              field.parentElement.classList.add('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              // error = true;
              errorMap.set(field, true);
            }
          } else if (field.selectr != null) {
            if (field.selectr.getValue() !== '') {
              field.parentElement.classList.remove('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.remove('show');
              } catch (e) {

              }
              formFieldsValue.push(
                `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
              );
            } else {
              field.parentElement.classList.add('is-invalid');
              try {
                field.parentElement.querySelector('.error-label').classList.add('show');
              } catch (e) {

              }
              // error = true;
              errorMap.set(field, true);
            }
          }
        }

        // non required fields
      } else if (field.type !== 'checkbox' && field.type !== 'radio') {
        if (formFields[i].value.length > 0) {
          formFieldsValue.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
          );
        }
      }
    }
  }

  if (errorMap.size > 0) {
    return [];
  }

  // if (error) {
  //   return [];
  // }
  return formFieldsValue.join('&');
}

function parseDate(input, format) {
  format = format || 'yyyy-mm-dd'; // default format
  const parts = input.match(/(\d+)/g);


  let i = 0;
  const
    fmt = {};
    // extract date-part indexes from the format
  format.replace(/(yyyy|dd|mm)/g, (part) => {
    fmt[part] = i++;
  });

  return new Date(parts[fmt.yyyy], parts[fmt.mm] - 1, parts[fmt.dd]);
}

function checkAge(date) {
  const givenDate = new Date(date);
  return ~~((Date.now() - givenDate) / (31557600000));
}

function submitForm(form) {
  if (typeof form !== 'undefined' || form !== '' || form !== null) {
    if (form.type === 'button') {
      form.addEventListener('click', (event) => {
        const mode = form.getAttribute('data-mode');
        if (mode === 'login-facebook') {
          logInWithFacebook(form);
        } else if (mode === 'connect-facebook') {
          logInWithFacebook(form, 'connect-facebook');
        } else if (mode === 'register-facebook') {
          logInWithFacebook(form, 'register-facebook');
        }
      });
    } else {
      const submit = form.querySelector('button[type=submit]');
      submit.addEventListener('click', (event) => {
        // form.addEventListener('submit', function (event) {
        event.preventDefault();

        // let form = event.target;
        const form = getClosest(event.target, '.sso-form');

        // console.log(form);

        if (typeof form !== 'undefined' && form !== '') {
          const mode = form.getAttribute('data-mode');
          // showMessage(form, '', '');
          // console.log(mode);
          if (mode === 'register-account-address') {
            if (checkFormFields(form).length) {
              const mySwiper = $('.swiper-container').swiper;

              mySwiper.slideNext();
              document.body.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
              });
            }
          } else if (mode === 'logout') {
            load(form.querySelector('button[type=submit]'));
            ajaxRequest(mode, '', form);
          } else if (mode === 'login-facebook') {
            // load(form.querySelector('button[type=submit]'));
            logInWithFacebook(form);
            // ajaxRequest(mode, "", form)
          } else if (mode === 'register-account') {
            const forms = $$('.register-form');


            let formData = [];
            if (checkFormFields(form).length) {
              for (let i = 0; i < forms.length; i++) {
                if (i === 0) {
                  formData = checkFormFields(forms[i]);
                } else {
                  formData += `&${checkFormFields(forms[i])}`;
                }
              }

              load(form.querySelector('button[type=submit]'));
              ajaxRequest(mode, formData, form);
            }
          } else if (mode === 'connect-facebook') {
            // load(form.querySelector('button[type=submit]'));
            logInWithFacebook(form, mode);
          } else if (mode === 'register-facebook') {
            // load(form.querySelector('button[type=submit]'));
            logInWithFacebook(form, mode);
          } else if (mode === null) {
            const formData = checkFormFields(form);
            if (formData.length) {
              load(form.querySelector('button[type=submit]'));
              form.submit();
            }
          } else {
            // normal forms
            const formData = checkFormFields(form);
            if (formData.length) {
              load(form.querySelector('button[type=submit]'));
              ajaxRequest(mode, formData, form);
            } else {
              showMessage(form, 400, '');
            }
          }
        }
      });
    }
  }
}

function logInWithFacebook(form, type) {
  // if (type === 'connect-facebook') {
  //     let form = $('#edit-account-form-facebook'),
  //         id = 'id=' + encodeURIComponent(form.elements[0].value);
  //     ajaxRequest('connect-facebook', 12 + '&' + id, form);
  // }

  FB.login((response) => {
    if (response.authResponse) {
      const a = `a=${encodeURIComponent(response.authResponse.accessToken)}`;
      if (type === 'register-facebook') {
        ajaxRequest('register-facebook', a, form);
      } else if (type === 'connect-facebook') {
        const form = $('#edit-account-form-facebook');


        const id = `id=${encodeURIComponent(form.elements[0].value)}`;
        ajaxRequest('connect-facebook', `${a}&${id}`, form);
      } else {
        ajaxRequest('login-facebook', a, form);
      }
    }
  }, { scope: 'public_profile,email,user_birthday' });
  return false;
}

function checkCapslock(field) {
  document.addEventListener('keydown', (event) => {
    const caps = event.getModifierState && event.getModifierState('CapsLock');
    if (caps) {
      field.classList.add('caps');
    }
  });
  document.addEventListener('keyup', (event) => {
    const caps = event.getModifierState && event.getModifierState('CapsLock');
    if (!caps) {
      field.classList.remove('caps');
    }
  });
}

/**
 * Get the closest matching element up the DOM tree.
 * @private
 * @param  {Element} elem     Starting element
 * @param  {String}  selector Selector to match against
 * @return {Boolean|Element}  Returns null if not match found
 */
const getClosest = function (elem, selector) {
  // Element.matches() polyfill
  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector
            || Element.prototype.mozMatchesSelector
            || Element.prototype.msMatchesSelector
            || Element.prototype.oMatchesSelector
            || Element.prototype.webkitMatchesSelector
            || function (s) {
              const matches = (this.document || this.ownerDocument).querySelectorAll(s);


              let i = matches.length;
              while (--i >= 0 && matches.item(i) !== this) {
              }
              return i > -1;
            };
  }

  // Get closest match
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }

  return null;
};

export default () => {
  const forms = $$('form.sso-form');

  for (let i = 0; i < forms.length; i++) {
    submitForm(forms[i]);
  }

  const fbButton = $$('.fb-login');

  for (let i = 0; i < fbButton.length; i++) {
    submitForm(fbButton[i]);
  }

  const pwFields = $$('input[type=password]');

  for (let i = 0; i < pwFields.length; i++) {
    checkCapslock(pwFields[i]);
  }
};
